module.exports = __webpack_public_path__ + "img/empty_black.40e9a478.png";